import React from 'react';
import { ExternalLink } from 'lucide-react';
import { siteConfig, portfolio, navigation } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-navy-950 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Centered Logo Section */}
        <div className="py-12 flex flex-col items-center border-b border-white/10">
          <img
            src={siteConfig.logo}
            alt="Sean Greenwood"
            className="h-56 md:h-72 w-auto mb-4"
          />
          <p className="text-silver-400 text-center max-w-md">
            Building legacies through strategic property and business excellence.
          </p>
        </div>

        {/* Main Footer */}
        <div className="py-12 grid md:grid-cols-3 gap-12">

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-6 text-white">Quick Links</h4>
            <ul className="space-y-3">
              {navigation.map((item) => (
                <li key={item.name}>
                  <button
                    onClick={() => scrollToSection(item.href)}
                    className="text-silver-400 hover:text-white transition-colors"
                  >
                    {item.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Companies & Affiliations */}
          <div>
            <h4 className="text-lg font-semibold mb-6 text-white">Affiliations</h4>
            <ul className="space-y-3">
              {portfolio.map((item) => (
                <li key={item.id}>
                  <a
                    href={item.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-silver-400 hover:text-white transition-colors inline-flex items-center gap-2"
                  >
                    {item.name}
                    <ExternalLink className="w-3 h-3" />
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-semibold mb-6 text-white">Get In Touch</h4>
            <ul className="space-y-3 text-silver-400">
              <li>
                <a href={`mailto:${siteConfig.email}`} className="hover:text-white transition-colors">
                  {siteConfig.email}
                </a>
              </li>
              <li>
                <a href={`tel:${siteConfig.phone}`} className="hover:text-white transition-colors">
                  {siteConfig.phone}
                </a>
              </li>
              <li>
                <a
                  href={siteConfig.calendlyUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-white transition-colors inline-flex items-center gap-2"
                >
                  Book Consultation
                  <ExternalLink className="w-3 h-3" />
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="py-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-silver-500 text-sm">
              © {currentYear} Sean Greenwood Consulting Services. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-silver-500 hover:text-white text-sm transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="text-silver-500 hover:text-white text-sm transition-colors">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
